import React, { useState, useMemo, useContext, useEffect } from "react";
import _ from "lodash";
import useApi from "api/useApi";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import UserService from "services/UserService";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { getAlertRules } from "services/ConfigServices";
import { criticityData, alerttypeData, alerttypeDataNoPersonalized, alertpredifinedrulesData, getObjectFromId } from "variables/lists/alerts";
import axios from "axios";
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'assets/css/customNotifications.css';
import UploadAlertRule from "./UploadAlertRule";

const StyledTextField = styled.input`
    height: 32px;
    width: 200px;
    border: 0px;
    padding: 0 32px 0 16px;
    &:hover {
      cursor: text;
    }
  `;

const ClearButton = styled.button`
    border: 0px solid rgba(0, 0, 0, 0.15);
    border-left: 0px;
    background-color: none;
    height: 34px;
    width: 32px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      cursor: pointer;
    }
  `;

const SearchContainer = styled.div`
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  `;

export default function useEntitesTable(props) {
  // Though this is a GET, use a POST & method override because the sorted and
  // filtered params are complex (arrays of objects) for easier parsing.
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const alertscreate = permis.includes("alerts_admin");

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sorted, setSorted] = useState();
  const [filtered, setFiltered] = useState();
  const [totalRows, setTotalRows] = useState(0);
  //const [idGroup, setIdGroup] = useState(2151);
  const [results, setResults] = useState({});
  const [gridState, setGridState] = useState();
  const [refresh, setRefresh] = useState(false);
  const [permissionList, setPermissionList] = useState([]);
  const [viewList, setViewList] = useState([]);
  const [loading, setLoading] = useState(true);


  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === chartIdGroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          getAlertRules(chartIdGroup),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setResults(response.data);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup, refresh]);
  // ----------------------------------------------------------

  const [filterText, setFilterText] = useState("");
  const [filterId, setFilterId] = useState("Text");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);


  const refreshTable = () => {
    console.log("refresh table");
    setRefresh(!refresh);
  };

  const FilterComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus={true}
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const setNotification = (status, text) => {
    if (status === 'success') {
      NotificationManager.success(text);
    }
    else {
      NotificationManager.error(text);
    }
  };

  const UploadComponent = ({ onUpload }) => (
    <>
      {/*<PublishIcon fontSize="medium" />
        <UploadText>Import</UploadText>*/}
      <UploadAlertRule type="button" onClick={onUpload} refetch={refreshTable} setLoading={setLoading} setNotification={setNotification} />

    </>
  );


  const filteredItems = _.get(results, "alertrules", []).filter(
    (item) =>
      (item.name && item.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.type && alerttypeData.find((x) => x.id == item.type) && alerttypeData.find((x) => x.id == item.type).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.category && item.category.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.description && item.description.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.criticity && criticityData.find((x) => x.id == item.criticity) && criticityData.find((x) => x.id == item.criticity).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.diffusion && JSON.stringify(item.diffusion).toLowerCase().includes(filterText.toLowerCase())) ||
      (item.groups[0] && groupInfoListById["" + item.groups[0]] && groupInfoListById["" + item.groups[0]].toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const onFilterText = (e) => setFilterText(e.target.value);

    return (
      <>
        <FilterComponent
          key="FilterComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {alertscreate ?
          <UploadComponent key="UploadComponent" onUpload={handleClear} />
          : <></>}
      </>
    );
  }, [filterText, resetPaginationToggle]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      // loading: loading,
      loading: false,
    },
    refreshTable,
    setLoading,
  };
}
